module.exports = __webpack_public_path__ + "img/workContents03-02_play.1b430f4e.gif";